import React from 'react';
import styles from './Footer.module.scss';
import MegaFooter from './MegaFooter/MegaFooter';
import FooterBottomBar from './FooterBottomBar/FooterBottomBar';
import { PureFooterMenu, PureFooterBottomBar, PureNewsLetter, RegionSelectorData } from './types';

export interface FooterProps {
  pureFooterMenu: PureFooterMenu;
  pureFooterBottomBar?: PureFooterBottomBar;
  footerLogo?: React.ReactNode;
  regionSelectorData?: RegionSelectorData;
  pureNewsLetter?: PureNewsLetter;
}

export const Footer = (props: FooterProps) => {
  return (
    <div
      id="footer"
      data-component="authorable/shared/navigation/footer/footer"
      className={`${styles.footer} printHide`}
    >
      <MegaFooter
        pureFooterMenu={props.pureFooterMenu}
        footerLogo={props.footerLogo}
        regionSelectorData={props.regionSelectorData}
        pureNewsLetter={props.pureNewsLetter}
      />
      <FooterBottomBar pureFooterBottomBar={props.pureFooterBottomBar} />
    </div>
  );
};
